// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templates-bg[data-v-605630c2]{height:100%;width:100%;position:absolute}.templates-bg__image[data-v-605630c2],.templates-bg__overlay[data-v-605630c2]{position:absolute;left:0;top:0;width:100%;height:100%}\n", ""]);
// Exports
module.exports = exports;
